import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  lifecycleConfirmCopy,
  LIFECYCLE_ACTION_LABELS,
} from '@yeshuman/sdk'
import type { LifecycleAction } from '@yeshuman/sdk'

type JobWorkspaceActionDialogsProps = {
  busy: boolean
  pendingConfirm: LifecycleAction | null
  onPendingConfirmChange: (open: boolean) => void
  onConfirmAction: () => void
  pendingDelete: boolean
  onPendingDeleteChange: (open: boolean) => void
  onConfirmDelete: () => void
}

export function JobWorkspaceActionDialogs({
  busy,
  pendingConfirm,
  onPendingConfirmChange,
  onConfirmAction,
  pendingDelete,
  onPendingDeleteChange,
  onConfirmDelete,
}: JobWorkspaceActionDialogsProps) {
  return (
    <>
      <AlertDialog
        open={pendingConfirm !== null}
        onOpenChange={(open) => {
          if (!open) onPendingConfirmChange(false)
        }}
      >
        <AlertDialogContent>
          {pendingConfirm ? (
            <>
              <AlertDialogHeader>
                <AlertDialogTitle>{lifecycleConfirmCopy(pendingConfirm).title}</AlertDialogTitle>
                <AlertDialogDescription>
                  {lifecycleConfirmCopy(pendingConfirm).description}
                </AlertDialogDescription>
              </AlertDialogHeader>
              <AlertDialogFooter>
                <AlertDialogCancel disabled={busy}>Cancel</AlertDialogCancel>
                <AlertDialogAction
                  disabled={busy}
                  onClick={(e) => {
                    e.preventDefault()
                    onConfirmAction()
                  }}
                >
                  {LIFECYCLE_ACTION_LABELS[pendingConfirm]}
                </AlertDialogAction>
              </AlertDialogFooter>
            </>
          ) : null}
        </AlertDialogContent>
      </AlertDialog>

      <AlertDialog
        open={pendingDelete}
        onOpenChange={(open) => {
          if (!open) onPendingDeleteChange(false)
        }}
      >
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Delete this draft job?</AlertDialogTitle>
            <AlertDialogDescription>
              This permanently removes the job and cannot be undone. Only draft jobs can be deleted.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel disabled={busy}>Cancel</AlertDialogCancel>
            <AlertDialogAction
              disabled={busy}
              className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
              onClick={(e) => {
                e.preventDefault()
                onConfirmDelete()
              }}
            >
              Delete job
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  )
}
